var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-chip',{attrs:{"color":_vm.params.data.Status == 1 ? 'success' : 'danger'}},[_vm._v("\n\t\t"+_vm._s(_vm.params.data.Status == 1 ? _vm.$t('Active') : _vm.$t('Passive'))+"\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }